import React from "react"
import parse from "html-react-parser"
import { Link } from "gatsby"

const external = string => string.substring(0, 4) === "http"

const useParser = markup =>
  parse(markup, {
    replace: node => {
      switch (node.name) {
        case "a":
          const {
            attribs: { href },
          } = node
          const text = node.children[0].data

          if (!external(href)) {
            return <Link to={href} children={text} />
          } else {
            return (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {text}
              </a>
            )
          }

        default:
          return node
      }
    },
  })

export default useParser
